import { useCallback } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionFaceSwap from '../../../redux/action/FJActionFaceSwap';
import { useDispatch } from 'react-redux';
import FJMobileFaceSwapPreset from './FJMobileFaceSwapPreset';
import { useSelector } from 'react-redux';

const FJMobileFaceSwapPresetContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const originCurLoadName = useSelector(state => state.faceSwap.originCurLoadName);

    const _onOriginTryThose = useCallback(
        item => {
            dispatch(FJActionFaceSwap.uploadOriginTryThoseImageAction(item));
        },
        [dispatch],
    );
    return <FJMobileFaceSwapPreset onOriginTryThose={_onOriginTryThose} originCurLoadName={originCurLoadName} />;
};

export default FJMobileFaceSwapPresetContainer;
